import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Estilos } from '../../../services/estilos/estilos';

export interface DialogData {
  title: string;
  content: string;
  showBtnCancel: boolean;
  btnCancelar: string;
  btnAceptar: string;
}

@Component({
  selector: 'lib-dialog-base',
  templateUrl: './dialog-base.component.html',
  styleUrls: ['./dialog-base.component.css']
})
export class DialogBaseComponent {

  estilos : Estilos = new Estilos();

  constructor(
    public dialogRef: MatDialogRef<DialogBaseComponent>,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    // console.log('Botones> ' + data.btnAceptar + ' ' + data.btnCancelar);
    this.estilos.cambioEstilos(this.elementRef);
    this.estilos.cambioEstilosSusComercio(this.elementRef);
  }

    onNoClick(): void {
      this.dialogRef.close();
    }
}
